<header class="modern-navbar">
    <!-- Top Bar avec Informations de Contact -->
    <div class="top-bar">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-12">
                    <div class="contact-info">
                        <div class="contact-item">
                            <i class="icofont-location-pin"></i>
                            <span>
                                <strong>Guinée - Conakry</strong>
                                <br/>
                                {{ appSettingService.value.address }}
                            </span>
                        </div>
                        <div class="contact-item">
                            <i class="icofont-phone"></i>
                            <span>
                                <strong>+224 {{ appSettingService.value.phone_number2 }}</strong>
                                <br/>
                                Appelez-nous
                            </span>
                        </div>
                        <div class="contact-item">
                            <i class="icofont-email"></i>
                            <span>
                                <strong>{{ appSettingService.value.email }}</strong>
                                <br/>
                                Contactez-nous
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-12">
                    <div class="top-actions">
                        <div class="social-links">
                            <a [href]="appSettingService.value.facebook_url" title="Facebook" target="_blank" class="social-link">
                                <i class="icofont-facebook"></i>
                            </a>
                            <a [href]="appSettingService.value.youtube_url" title="Youtube" target="_blank" class="social-link">
                                <i class="icofont-youtube-play"></i>
                            </a>
                            <a [href]="appSettingService.value.twiter_url" title="Twitter" target="_blank" class="social-link">
                                <i class="icofont-twitter"></i>
                            </a>
                            <a [href]="appSettingService.value.instagram_url" title="Instagram" target="_blank" class="social-link">
                                <i class="icofont-instagram"></i>
                            </a>
                        </div>
                        <div class="auth-buttons">
                            <a routerLink="/login" class="btn-login">
                                Connexion
                            </a>
                            <a routerLink="/create-account" class="btn-register">
                                S'enregistrer
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Main Navigation -->
    <nav class="main-navbar">
        <div class="container">
            <div class="navbar-wrapper">
                <!-- Logo -->
                <div class="navbar-brand">
                    <a routerLink="/" class="logo-link">
                        <img [src]="appSettingService.value.logo" alt="BSTP Logo" class="logo-img">
                    </a>
                </div>

                <!-- Mobile Menu Toggle -->
                <div class="mobile-toggle" (click)="toggleMobileMenu()">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <!-- Navigation Menu -->
                <div class="navbar-menu" [class.active]="isMobileMenuOpen">
                    <ul class="nav-menu">
                        <li class="nav-item">
                            <a routerLink="/" 
                               class="nav-link" 
                               routerLinkActive="active"
                               [routerLinkActiveOptions]="{ exact: true }"
                               (click)="closeMobileMenu()">
                                Accueil
                            </a>
                        </li>

                        <li class="nav-item">
                            <a routerLink="/requests" 
                               class="nav-link" 
                               routerLinkActive="active"
                               [routerLinkActiveOptions]="{ exact: true }"
                               (click)="closeMobileMenu()">
                                Offres
                            </a>
                        </li>

                        <li class="nav-item dropdown">
                            <a href="#" 
                               class="nav-link dropdown-toggle" 
                               (click)="toggleDropdown('qui-sommes-nous', $event)">
                                Qui sommes-nous?
                                <i class="icofont-simple-down dropdown-arrow" 
                                   [class.rotated]="activeDropdown === 'qui-sommes-nous'"></i>
                            </a>
                            <ul class="dropdown-menu" [class.show]="activeDropdown === 'qui-sommes-nous'">
                                <li class="dropdown-item">
                                    <a routerLink="/mot-du-directeur-executif" 
                                       class="dropdown-link"
                                       routerLinkActive="active"
                                       [routerLinkActiveOptions]="{ exact: true }"
                                       (click)="closeMobileMenu()">
                                        Mot du directeur exécutif
                                    </a>
                                </li>
                                <li class="dropdown-item">
                                    <a routerLink="/about" 
                                       class="dropdown-link"
                                       routerLinkActive="active"
                                       [routerLinkActiveOptions]="{ exact: true }"
                                       (click)="closeMobileMenu()">
                                        À propos de la BSTP
                                    </a>
                                </li>
                                <li class="dropdown-item">
                                    <a routerLink="/bstp-team" 
                                       class="dropdown-link"
                                       routerLinkActive="active"
                                       [routerLinkActiveOptions]="{ exact: true }"
                                       (click)="closeMobileMenu()">
                                        La BSTP Team
                                    </a>
                                </li>
                                <li class="dropdown-item">
                                    <a routerLink="/missions" 
                                       class="dropdown-link"
                                       routerLinkActive="active"
                                       [routerLinkActiveOptions]="{ exact: true }"
                                       (click)="closeMobileMenu()">
                                        Missions
                                    </a>
                                </li>
                                <li class="dropdown-item">
                                    <a routerLink="/faq" 
                                       class="dropdown-link"
                                       routerLinkActive="active"
                                       [routerLinkActiveOptions]="{ exact: true }"
                                       (click)="closeMobileMenu()">
                                        FAQs
                                    </a>
                                </li>
                            </ul>
                        </li>

                        <li class="nav-item dropdown">
                            <a href="#" 
                               class="nav-link dropdown-toggle"
                               (click)="toggleDropdown('performez', $event)">
                                Performez
                                <i class="icofont-simple-down dropdown-arrow"
                                   [class.rotated]="activeDropdown === 'performez'"></i>
                            </a>
                            <ul class="dropdown-menu" [class.show]="activeDropdown === 'performez'">
                                <li class="dropdown-item">
                                    <a routerLink="/programme-d-amelioration-de-contenu" 
                                       class="dropdown-link"
                                       routerLinkActive="active"
                                       [routerLinkActiveOptions]="{ exact: true }"
                                       (click)="closeMobileMenu()">
                                        Programme d'amélioration continu
                                    </a>
                                </li>
                                <li class="dropdown-item">
                                    <a routerLink="/labelisation-des-pme-pmi" 
                                       class="dropdown-link"
                                       routerLinkActive="active"
                                       [routerLinkActiveOptions]="{ exact: true }"
                                       (click)="closeMobileMenu()">
                                        Labellisation des PME/PMI
                                    </a>
                                </li>
                                <li class="dropdown-item">
                                    <a href="https://www.qualifpme.bstpgn.com" target="_blank" 
                                       class="dropdown-link"
                                       routerLinkActive="active"
                                       [routerLinkActiveOptions]="{ exact: true }"
                                       (click)="closeMobileMenu()">
                                        Rejoignez QualifPME
                                    </a>
                                </li>
                            </ul>
                        </li>

                        <li class="nav-item">
                            <a routerLink="/guides" 
                               class="nav-link" 
                               routerLinkActive="active"
                               [routerLinkActiveOptions]="{ exact: true }"
                               (click)="closeMobileMenu()">
                                Guide utilisateur
                            </a>
                        </li>

                        <li class="nav-item">
                            <a routerLink="/partners" 
                               class="nav-link" 
                               routerLinkActive="active"
                               [routerLinkActiveOptions]="{ exact: true }"
                               (click)="closeMobileMenu()">
                                Partenaires
                            </a>
                        </li>

                        <li class="nav-item">
                            <a routerLink="/blog" 
                               class="nav-link" 
                               routerLinkActive="active"
                               [routerLinkActiveOptions]="{ exact: true }"
                               (click)="closeMobileMenu()">
                                Actualités
                            </a>
                        </li>

                        <li class="nav-item">
                            <a routerLink="/contact" 
                               class="nav-link" 
                               routerLinkActive="active"
                               [routerLinkActiveOptions]="{ exact: true }"
                               (click)="closeMobileMenu()">
                                Contactez-nous
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
</header>
